import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BaseModal } from 'react-bootstrap';

import Form from './Form';

export default function Modal({ show, onHide }) {
  return (
    <BaseModal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <BaseModal.Header closeButton>
        <BaseModal.Title>Create a Webinar</BaseModal.Title>
      </BaseModal.Header>

      <BaseModal.Body>
        <Form onHide={onHide} />
      </BaseModal.Body>
    </BaseModal>
  );
}

Modal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
